<template>
    <q-page>
     <div class="q-pa-md">
     <div class="text-h4">Incidencias</div>
    <q-table 
    dense
    :pagination="{rowsPerPage: 10}"
    :rows-per-page-options="[0]"
    virtual-scroll
    flat
    bordered
    :rows="incidencias"
    separator="cell">
       <template v-slot:header>
      <q-tr class="bg-dark text-white">
            <q-th key="Descripcion"  align="left">Descripción</q-th>
            <q-th key="Color" align="left">Color</q-th>
            <q-th auto-width key="Actions" align="center">   
                <q-btn icon="add" color="dark" size="sm" padding="5px 5px" @click="editIncidencia(0)"/>
            </q-th>
      </q-tr>
      </template>
      <template v-slot:body="props">
        <q-tr>
            <q-td>
                {{ props.row.Descripcion }}
            </q-td>
            <q-td auto-width>
                <q-icon name="stop" v-bind:style="{color: props.row.Color}"  size="sm"/>
            </q-td>
             <q-td auto-width>
               <q-btn-group>
                <q-btn icon="edit" color="secondary" size="sm" padding="5px 5px" @click="editIncidencia(props.row.IdIncidencia)"/>
                <!--<q-btn icon="delete" color="negative" size="sm" padding="5px 5px" @click="showIncidencia(props.row.IdIncidencia)"/>-->
            </q-btn-group>
            </q-td>
        </q-tr>
      </template>
      </q-table>
     </div>
    </q-page>

    <q-dialog v-model="edit" persistent>
     <q-card style="width: 700px; max-width: 80vw;">
        <q-toolbar class="bg-dark text-white">
          <q-toolbar-title>Incidencia</q-toolbar-title>
          <q-btn flat round dense icon="close" v-close-popup />
        </q-toolbar>
        <q-card-section>
            <q-form class="q-gutter-md" @submit.prevent="saveincidencia">
              <q-input outlined dense v-model="incidencia.Descripcion" label="Descripción" :rules="rules"/>
              <!--<q-input outlined disable v-model="incidencia.Color" label="Color de incidencia" :rules="rules"/>-->
              <q-color outlined dense v-model="incidencia.Color" default-view="palette" label="Color de incidencia" :rules="rules"/>
              <q-toggle dense v-model="incidencia.Resaltar" label="Resaltar incidencia" left-label />
              <q-toggle dense v-model="incidencia.SabDom" label="Sábados y Domingos" left-label />
              
              <div>
              <div class="q-pa-md q-gutter-sm float-right">
                    <q-btn color="secondary" text-color="white" label="Cerrar" @click="edit=false"/>
                    <q-btn color="primary" label="Guardar" type="submit"/>
                </div>
              </div>
            </q-form>
        </q-card-section>
      </q-card>
    </q-dialog>
</template>

<script>
import http from "@/services/http"

export default {
data: () => ({
    incidencias:[],
      incidencia:{},
      edit:false,
      del:false,
      rules: [v => !!v || 'Campo obligatorio',],
    }),
    methods:{
        async initialize(){
             this.incidencias = await http.get('catalogos/incidencias');
        },
        async editIncidencia(id){
            if(id===0){
                this.incidencia = { Descripcion:'', Color : '#000000', Resaltar: false, SabDom: false };
            }
            else{
                this.incidencia = await http.get(`catalogos/incidencias/${id}`)
            }
            this.edit=true
        },
        async showincidencia(id){
          this.handpunch = await http.get(`catalogos/incidencias/${id}`)
          this.del=true
        },
        async saveincidencia(){
            await http.post('catalogos/incidencia',this.incidencia);
            this.edit =false
            this.initialize();
        },
        async delincidencia(){
            await http.delete(`catalogos/delincidencia/${this.incidencias.IdIncidencia}`)
            this.del =false
            this.initialize();
        }
    },
    created(){
        this.initialize();
    },
}
</script>

